/**
 * `localStorage` čtené i zapisované tak, aby přístup nikdy nevyhodil výjimku: v prohlížeči se
 * zablokovanými daty stránek hodí i pouhé čtení, což by jinak shodilo konstrukci komponenty.
 */
export function isDismissed(key: string): boolean {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

export function setDismissed(key: string): void {
  try {
    localStorage.setItem(key, 'true');
  } catch {
    // Skrytí se nepřenese do dalšího načtení, karta se ale musí dát zavřít i tak.
  }
}
